import React from "react"

import { Form, Formik } from "formik"

import { gql, useMutation } from "hooks/urql"

import { handleFailure } from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody, { Footer } from "components/ModalWithProvidedBody"

type DeleteClassPeriodProps = {
  periodId: string
}

const DeleteClassPeriod: React.FC<DeleteClassPeriodProps> = ({ periodId }) => {
  const [, deleteClassPeriod]: any[] = useMutation(deleteClassPeriodMutation)

  const handleSubmit = (
    _values: Record<string, never>,
    actions: any,
    closeModal: VoidFunction
  ) => {
    deleteClassPeriod({ id: periodId })
      .then((response: any) => {
        const failures = response.data?.deleteAcrClassPeriod?.failures
        if (failures?.length > 0) {
          handleFailure(actions, failures)
        } else {
          window.location.reload()
        }
      })
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      modalTitle="Delete Class Period"
      buttonText="Delete"
      buttonClassName="btn btn-danger btn-sm"
    >
      {({ closeModal }: { closeModal: VoidFunction }) => (
        <Formik
          initialValues={{}}
          onSubmit={(values, actions) =>
            handleSubmit(values, actions, closeModal)
          }
        >
          <Form>
            <div className="modal-body">
              <p>
                Are you sure you want to delete this class period? Students will
                be unable to join during this time.
              </p>
            </div>
            <Footer cancelAction={closeModal} submitText="Delete" isDangerous />
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const deleteClassPeriodMutation = gql`
  mutation DeleteAcrClassPeriod($id: ID!) {
    deleteAcrClassPeriod(id: $id) {
      failures {
        message
      }
    }
  }
`

export default DeleteClassPeriod
